import {ActionWithPayload} from './index';
import {AppState} from "@store/reducers/index";
import {Address} from '@models/address.interface';
import {
  AddressPayload,
  LOAD_ADDRESSES_SUCCESS, LOAD_FILTERED_ADDRESSES_SUCCESS,
  SET_ACTIVE_ADDRESS_SEARCH
} from '@store/actions/addresses.action';

export type AddressesState = {
  total: number,
  current_page_size: number,
  current_page: number,
  activeSearch: string,
  data: {
    [key: number]: {
      [key: number]: Address[]
    }
  },
  import: {
    encoded_file: string,
    type: string
  },
  filteredData: {
    [search: string]: {
      total: number,
      data: {
        [key: number]: {
          [key: number]: Address[]
        }
      }
    },
  }
}

export function addressesReducer (
  state = {
    total: null,
    current_page_size: null,
    current_page: null,
    activeSearch: null,
    data: null,
    filteredData: null
  }, action: ActionWithPayload<AddressPayload>) {
  switch (action.type) {

    case LOAD_ADDRESSES_SUCCESS:
      const pages = state.data && state.data[action.payload.current_page_size] || {};
      return {
        ...state,
        total: action.payload.total,
        current_page_size: action.payload.current_page_size,
        data: {
          ...state.data,
          [action.payload.current_page_size]: {
            ...pages,
            [action.payload.current_page]: action.payload.data
          }
        }
      };

    case LOAD_FILTERED_ADDRESSES_SUCCESS:
      const totalFilteredData = state.filteredData || {};
      const filteredDataForActiveSearch = totalFilteredData[action.payload.activeSearch] || {};
      const filteredAddressesForActiveSearch = filteredDataForActiveSearch.data || {};
      return {
        ...state,
        filteredData: {
          ...totalFilteredData,
          [action.payload.activeSearch]: {
            ...filteredDataForActiveSearch,
            total: action.payload.total,
            data: {
              ...filteredAddressesForActiveSearch,
              [action.payload.current_page_size]: {
                ...(filteredAddressesForActiveSearch[action.payload.current_page_size] || {}),
                [action.payload.current_page]: action.payload.data
              }
            }
          }
        }
      };

    case SET_ACTIVE_ADDRESS_SEARCH:
      return {
        ...state,
        activeSearch: action.payload.activeSearch
      };

    default:
      return state;
  }
}

export const selectAddresses = (state: AppState) => state.addresses;



// WEBPACK FOOTER //
// ./src/app/store/reducers/addresses.reducer.ts